import { useState, memo } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import TextInput from "src/components/TextInput/TextInput";

interface IProps {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

function ProductCatalogSearch({ value, onChange }: IProps) {
  return (
    <TextInput
      mt={0}
      label="Search"
      radius="xl"
      size="sm"
      icon={<AiOutlineSearch />}
      value={value}
      onChange={onChange}
      styles={{ label: { left: 32 } }}
    />
  );
}

export default memo(ProductCatalogSearch);
